// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiple-choice-question--choiceWrapper--QQfZjt6g {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  align-items: center;\n  margin-top: 12px;\n}\n.multiple-choice-question--choiceWrapper--QQfZjt6g .multiple-choice-question--choiceIcon--19C9wkRP {\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  border: 1.5px solid #979797;\n  background-color: white;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n.multiple-choice-question--choiceWrapper--QQfZjt6g .multiple-choice-question--correct--31IInTy- {\n  font-weight: bold;\n}\n.multiple-choice-question--questionText--3KpCr3Mo {\n  margin: 0px 20px 10px 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"choiceWrapper": "multiple-choice-question--choiceWrapper--QQfZjt6g",
	"choiceIcon": "multiple-choice-question--choiceIcon--19C9wkRP",
	"correct": "multiple-choice-question--correct--31IInTy-",
	"questionText": "multiple-choice-question--questionText--3KpCr3Mo"
};
module.exports = exports;
